import { useSelector } from 'store';

/**
 * מצבי טעינה לפי פאנל — בלי לשנות לוגיקת API; רק קריאה מ-store קיים.
 * פאנל תבניות: אוברליי רק בטעינה ראשונה כשאין עדיין נתונים. אם התבניות כבר נטענו ב-login,
 * רענון/API לא מסתיר את הרשימה (המשתמש רואה ספינר בכפתור רענון בכותרת).
 */
export function useChatToolsPanelLoading(panelId: string, isActive: boolean): boolean {
  const templatesLoading = useSelector((state) => state.templates.whatsappTemplatesLoading);
  const hasTemplateData = useSelector(
    (state) =>
      state.templates.whatsappOriginalTemplates.length > 0 ||
      state.templates.whatsappTemplates.length > 0,
  );

  if (!isActive) return false;

  switch (panelId) {
    case 'chat-templates-menu':
      return templatesLoading && !hasTemplateData;
    default:
      return false;
  }
}
